module.exports = __webpack_public_path__ + "img/google.8134b03a.svg";